export class SearchField {
    id: any;
    displayName: string;

    constructor(id:any, displayName:string) {
        this.id = id;
        this.displayName = displayName;
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/search/entities/search-field.ts